import React, {useEffect, useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import Input from "@amzn/meridian/input";
import {
    getAisleNamePattern,
    isValidEntry,
    isValidLedPortNumber,
    validateUniqueEntries
} from "../../../util/Validations";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import SearchableSelectModal from "../../../commonui/SearchableSelectModal";
import {CONFIG_TYPE, DEFAULT_AISLE_TYPE} from "../../../util/Constants";
import {TableCell} from "@amzn/meridian/table";
import {getObjectByIndex} from "../../../util/LEDControllerUtil";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import Icon from "@amzn/meridian/icon";
import PropTypes from "prop-types";


const AisleRowModal = (props) => {

    const {formatMessage} = props.intl;
    const {config, mac, getDraftData, setDraftData, aisleTypes, maxPorts} = props;

    // States
    const [aisleName, setAisleName] = useState(config.aisleName ? config.aisleName : null);
    const [portNumber, setPortNumber] = useState(config.portNumber ? config.portNumber : null);
    const [aisleType, setAisleType] = useState(config.aisleType ? config.aisleType : null);

    // Errors
    const [aisleNameErr, setAisleNameErr] = useState(false)
    const [portNumberErr, setPortNumberErr] = useState(false)
    const [aisleTypeErr, setAisleTypeErr] = useState(false)

    useEffect(() => {
        const draftData = getDraftData();
        if (draftData && draftData.length > 0 && aisleType) {
            const aisleConfig = getObjectByIndex(draftData, config.index)
            if (aisleConfig) {
                aisleConfig.aisleType = aisleType;
                setDraftDataForLed(draftData)
            }
        }
    }, [aisleType]);

    const setDraftDataForLed = (data) => {
        setDraftData({
            data: data,
            stateKey: CONFIG_TYPE.LED_CONTROLLER_CONFIGURATION,
            subKey: mac,
            override: true
        })
    }

    const onChangeAisleName = (value) => {
        setAisleName(value)
        const draftData = getDraftData();
        const aisleConfig = getObjectByIndex(draftData, config.index)
        aisleConfig.aisleName = value;
        setDraftDataForLed(draftData)
    }

    const onChangePortNumber = (value) => {
        const portNumber = parseInt(value, 10);
        setPortNumber(value)
        const draftData = getDraftData();
        const aisleConfig = getObjectByIndex(draftData, config.index)
        aisleConfig.portNumber = portNumber;
        setDraftDataForLed(draftData)
    }

    const onRemove = () => {
        let draftData = getDraftData();
        draftData = draftData.filter(item => item.index !== config.index)
        setDraftDataForLed(draftData)
    }

    return [
        <TableCell>
            <Input
                className="aisle-name-input"
                value={aisleName}
                onChange={onChangeAisleName}
                type="text"
                placeholder="Search"
                width="70%"
                onBlur={() => {
                    setAisleNameErr(!isValidEntry(aisleName, getAisleNamePattern()) ||
                        !validateUniqueEntries(Object.values(getDraftData()).map(item => item.aisleName)))
                }}
                error={aisleNameErr}
                size="small"/>
        </TableCell>,
        <TableCell>
            <Input
                className="port-number-input"
                value={portNumber}
                onChange={onChangePortNumber}
                type="text"
                placeholder="Search"
                width="70%"
                size="small"
                onBlur={() => {
                    setPortNumberErr(!isValidLedPortNumber(portNumber, maxPorts) ||
                    !validateUniqueEntries(Object.values(getDraftData()).map(item => item.portNumber)))
                }}
                error={portNumberErr}
            />
        </TableCell>,
        <TableCell>
            <Column width="80%">
            <SearchableSelectModal preSelectedValue={aisleType ? aisleType: DEFAULT_AISLE_TYPE}
                                   error={aisleTypeErr} setError={setAisleTypeErr}
                                   selectedValue={aisleType} setSelectedValue={setAisleType}
                                   options={aisleTypes}
                                   htmlId="searchable-input"
                                   placeholderValue={formatMessage({id: "modal.selectAisleType"})}
                                   placeholderDefaultValue={"Select Aisle Type"}/>
            </Column>

        </TableCell>,
        <TableCell>
            <Button type="tertiary" size="small" onClick={onRemove}>
                <Icon tokens={trashTokens}/>
                <FormattedMessage id="modal.remove" defaultMessage="Remove"/>
            </Button>
        </TableCell>
    ]
}

AisleRowModal.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    config: PropTypes.object,
    mac: PropTypes.string.isRequired,
    getDraftData: PropTypes.func.isRequired,
    setDraftData: PropTypes.func.isRequired,
    aisleTypes: PropTypes.array.isRequired,
    maxPorts: PropTypes.number
};

export default injectIntl(AisleRowModal);


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/modal/AisleRowModal.js